import { createSelector } from 'reselect'
import { DefaultState } from '../reducers/DefaultState'
import * as SelectorUtils from './utils'

const getRediscoverNetworkId = (state, props) => {
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return topicId
}

const getSelectedGenre = (state) => {
  return state.rediscover.selectedGenre
}

const getSelectedGenreNetwork = (state) => {
  return state.rediscover.selectedGenreNetwork
}

/* Fetches the topics byId state */
const getByGenre = (state) => {
  return state.rediscover.byGenre
}

const getRediscoverByIdState = (state, props) => {
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return state.rediscover.byId[topicId]
}

const getRediscoverNetworkDetailsState = createSelector(
  [getRediscoverByIdState],
  (state) => {
    return (state || {}).rediscoverNetwork || DefaultState
  }
)

const makeRediscoverTopicIdSelector = () => {
  return createSelector(
    [getRediscoverNetworkId],
    topicId => {
      return topicId
    }
  )
}

const makeRediscoverNetworkDetailsSelector = () => {
  return createSelector(
    [getRediscoverNetworkDetailsState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeRediscoverThumbnailsRootSelector = () => {
  return createSelector(
    [getSelectedGenre, getSelectedGenreNetwork, getByGenre],
    (genre, network, thumbnails) => {
      return (thumbnails[genre] || {})[network]
    }
  )
}

const makeRediscoverGenreDemoRootSelector = () => {
  return createSelector(
    [getSelectedGenre, getByGenre],
    (genre, genreDemo) => {
      return (genreDemo[genre] || {}).demographics
    }
  )
}

const makeDiscoverDemoSummaryRootSelector = () => {
  return createSelector(
    [getSelectedGenre, getByGenre],
    (genre, genreDemo) => {
      return (genreDemo[genre] || {}).demoSummary
    }
  )
}

const makeRediscoverThumbnailsSelector = () => {
  const getRediscoverThumbnails = makeRediscoverThumbnailsRootSelector()
  return createSelector(
    [getRediscoverThumbnails],
    (thumbnails) => {
      return thumbnails
    }
  )
}

const makeRediscoverGenreDemoSelector = () => {
  const getGenreDemo = makeRediscoverGenreDemoRootSelector()
  return createSelector(
    [getGenreDemo],
    (genreDemo) => {
      return genreDemo
    }
  )
}

const makeDiscoverDemoSummarySelector = () => {
  const getDemoSummary = makeDiscoverDemoSummaryRootSelector()
  return createSelector(
    [getDemoSummary],
    (demoSummary) => {
      return demoSummary
    }
  )
}


// -----------------------------------------------------------------------------

// Exports

// -----------------------------------------------------------------------------

export {
  makeRediscoverTopicIdSelector,
  makeRediscoverNetworkDetailsSelector,
  makeRediscoverThumbnailsSelector,
  makeRediscoverGenreDemoSelector,
  makeDiscoverDemoSummarySelector
}
